import { FC } from "react";
import "./SearchLoader.scss";

interface SearchLoaderProps {
  loading: boolean;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
}

const SearchLoader: FC<SearchLoaderProps> = ({
  loading,
  children,
  disabled,
  className,
  onClick
}) => {
  return (
    <button
      className={`search-loader-btn ${className || ""}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? <span className="search-loader-btn__spinner" /> : children}
    </button>
  );
};

export default SearchLoader;
